
<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <div class="side pull-left" ref="sidebar" :style="{top: sideTop + 'px'}">
        <div class="side-user">
          <div class="avatar pull-left"><img src="/static/img/avatar.jpg" alt="用户头像"></div>
          <div class="info pull-left">
            <p class="name" style="cursor: pointer" v-show="info.status===0" @click="$router.push('/authentication')">未实名，去认证</p>
            <p class="name" v-show="info.status===1">已认证，{{info.name}}</p>
            <p class="phone">{{info.phone}}</p>
            <p class="side-bottom"><span class="time">注册时间</span>{{info.registerTime}}</p>
          </div>
        </div>
        <div class="side-content">
          <!--<div class="item">-->
            <!--<p>借款总额(元)</p>-->
            <!--<span>{{info.sumAmount|currency}}</span>-->
          <!--</div>-->
          <!--<div class="item">-->
            <!--<p>待还本金(元)</p>-->
            <!--<span>{{info.dfAmount|currency}}</span>-->
          <!--</div>-->
          <!--<div class="item">-->
            <!--<p>已还本金(元)</p>-->
            <!--<span>{{info.yfAmount|currency}}</span>-->
          <!--</div>-->
        </div>
      </div>
      <div class="content pull-right">
        <!-- <div class="box" v-for="(item, index) in list" @click="showDetail(index)" :key="index">
          <div class="title-wrap">
            <h4 class="order-title">{{item.productName}}</h4>
            <span class="pull-right lending">{{item.statusName}}</span>
          </div>
          <p class="order-number"><span>{{item.no}}</span></p>
          <hr>
          <div class="row">
            <div class="col-xs-6">
              <p>申请日期：{{(item.addTime || '').substr(0, 10)}}</p>
              <p>借款期限：{{item.duration}}{{['天','月'][item.durationType]}}</p>
            </div>
            <div class="col-xs-6">
              <p>贷款金额：<span>{{item.borrowMoney|currency}}</span> 元</p>
              <p>还款方式：到期还本付息</p>
            </div>
          </div>
        </div> -->
        <router-view/>
      </div>
    </div>
  </div>
</template>

<script>
  import {bindEvent, removeEvent} from '@/util'

  export default {
    name: 'Order',
    data () {
      return {
        sideTop: 30,
        info: {}, // 用户信息
        list: [], // 借款列表
        listNoMore: false
      }
    },
    created () {
      this.getUserInfo()
    },
    mounted () {
      this.offsetTop = this.$refs.sidebar.offsetTop
      this.offsetHeight = this.$refs.sidebar.offsetHeight
      this._onScroll = (e) => {
        this.onScroll(e)
      }
      bindEvent(window, 'scroll', this._onScroll)
      this.$nextTick(() => {
        if (this.$browser.firefox) {
          document.documentElement.scrollTop = 0
        } else {
          document.body.scrollTop = 0
        }
      })
    },
    beforeDestroy () {
      removeEvent(window, 'scroll', this._onScroll)
    },
    methods: {
      getUserInfo () {
        let token = this.$store.state.token
        let time = Date.now()
        this.$http({
          url: '/center/getUserInfo.jhtml',
          data: {
            uid: token.uid,
            time
          },
          done: (info) => {
            this.info = info || {}
          }
        })
      },
      onScroll (e) {
        let scrollHeight = (document.documentElement || document.body).scrollHeight
        let scrollTop = document.body.scrollTop || (document.documentElement || document.body).scrollTop
        let min = this.offsetTop * 2 + this.offsetHeight + 307
        if (scrollHeight - scrollTop <= min) {
          this.sideTop = scrollHeight - min - this.offsetTop
        } else if (scrollTop > this.offsetTop) {
          this.sideTop = scrollTop + this.offsetTop
        } else {
          this.sideTop = this.offsetTop
        }
      }
      // showDetail (index) {
      //   let item = this.list[index]
      //   this.$router.push(`/u/order/${item.no}`)
      // }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../stylus/mixin'
  .section-container
    background-color #f4faff
  .main-container
    position relative
    padding 30px 0 50px
    min-height 609px
  .side
    position absolute
    top 30px
    padding 30px 20px
    width 310px
    height 490px
    line-height 1
    // border 1px solid rgb(238, 238, 238)
    transition top 30ms linear
    -ms-transition top 30ms linear
    background-repeat repeat
    background-color #fff
    box-shadow 1px 3px 18px 0 rgba(0,0,0,0.16)
    .side-user
      // display table
      // vertical-align middle
    .side-user
      width 100%
      height 100px
      color #0068b7
      border-radius 5px
      .avatar
        width 40px
        height 120px
      .info
        width 226px
      .name
        ellipsis()
        height 24px
        font-size 18px
        font-weight bold
        margin-bottom 30px
      .phone
        font-size 18px
      .side-bottom
        width 214px
        height 32px
        line-height 22px
        font-size 16px
        position relative
        &:after
          content ''
          position absolute
          width 33px
          height 5px
          background #0068b7
          bottom 0
          left 0
        .time
          position relative
          padding-right 10px
          margin-right 10px
          &:after
            content ''
            position absolute
            right 0
            top 2px
            width 2px
            height 18px
            background #0068b7
    .side-content
      color #1a4369
      .item
        padding 34px 0 10px 40px
        >p
          font-size 18px
          color #666
          margin-bottom 22px
        >span
          font-size 26px
          color #333
  .content
    width 850px
    .box
      margin 0 auto 32px
      padding 26px 20px 10px
      font-size 16px
      color #333
      background-color #fff
      cursor pointer
      p
        margin-top 10px
        margin-bottom 20px
      hr
        border-top-color rgba(107,125,142,.1)
        margin-top 20px
        margin-bottom 20px
      .title-wrap
        height 26px
        margin-bottom 10px
      .order-title
        display inline-block
        margin 0
        font-size 24px
        color #333
      .lending
        padding 1px 8px
        color rgb(43, 158, 252)
        font-weight 600
        border 1px solid rgb(43, 158, 252)
        border-radius 3px
      .order-number
        margin 0 auto 15px
        span
          padding 0 5px
          font-size 14px
          border 1px solid rgb(51, 51, 51)
          border-radius 3px

</style>



// WEBPACK FOOTER //
// order.vue?87f4e870